/**
 * Subcaminho público da console (ex.: /hive), lido da tag <base href> do index.html. A tag é reescrita no boot do
 * contêiner a partir de HIVE_BASE_PATH (deploy/console/10-hive-base-path.sh), então a mesma imagem serve na raiz ou
 * em qualquer subcaminho. Sem a tag (desenvolvimento, testes, console do provedor) vale a raiz.
 *
 * Caminhos da aplicação ("/assets/1") são relativos a este prefixo: o roteador usa como basename, e o que vai direto ao
 * navegador (window.location, window.open, service worker) passa por {@link withBase}.
 */
export function basePath(): string {
  if (typeof document === 'undefined') return '';
  const href = document.querySelector('base')?.getAttribute('href');
  if (!href) return '';
  try {
    return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
  } catch {
    return '';
  }
}

/** Caminho da aplicação com o subcaminho na frente: withBase('/') → '/hive/'. */
export function withBase(path: string): string {
  return basePath() + (path.startsWith('/') ? path : `/${path}`);
}

/** Caminho da aplicação a partir do endereço do navegador: '/hive/auth/saml' → '/auth/saml'. */
export function appPath(pathname: string = typeof window === 'undefined' ? '/' : window.location.pathname): string {
  const base = basePath();
  if (!base) return pathname;
  if (pathname === base) return '/';
  return pathname.startsWith(`${base}/`) ? pathname.slice(base.length) : pathname;
}
